window.onload = function(){
 var linkmsg=document.getElementById("linkmsg");
 linkmsg.style.visibility="visible";
 linkmsg.innerHTML="カラーを選択してください";
 document.getElementById("message").innerHTML = "";
    message.style.visibility="hidden";
 document.getElementById("opmsg").innerHTML = "<p> </p>";
    opmsg.style.visibility="hidden";
}
// tomamuサイズ画像変更
function showimg1(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/tomamu_size.gif?v=1643472585";
document.getElementById("message").innerHTML = "<p> </p>";
message.style.visibility="hidden";
document.getElementById("opmsg").innerHTML = "<p> </p>";
opmsg.style.visibility="hidden";
}
function showimg2(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/tomamu_size_legnt.gif?v=1643473075";
document.getElementById("message").innerHTML = "<p>※本体の高さに6cmプラスとなります</p>";
message.style.visibility="visible";
document.getElementById("opmsg").innerHTML = "<p>※脚を除く本体の高さをご記入ください</p>";
opmsg.style.visibility="visible";
}
function showimg3(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/tomamu_size_legbr.gif?v=1643473075";
document.getElementById("message").innerHTML = "<p>※本体の高さに6cmプラスとなります</p>";
message.style.visibility="visible";
document.getElementById("opmsg").innerHTML = "<p>※脚を除く本体の高さをご記入ください</p>";
opmsg.style.visibility="visible";
}
// Tomamu サイズオーダー
function checkBtn(){
 var idCloth = document.getElementsByName( "cava_tab" ) ;
 var strCloth = "";
 var i=0;
 for ( strCloth="", i=idCloth.length; i--; ) {
  if ( idCloth[i].checked ) {
   strCloth = idCloth[i].id.slice(4);
   break ;
  }
 }
 var idColor = document.getElementsByName( "colortype" ) ;
 var strColor=""
 for (strColor="", i=idColor.length; i--; ) {
  if ( idColor[i].checked ) {
   strColor = idColor[i].id ;
   break ;
  }
 }
 var linkmsg=document.getElementById("linkmsg");
 var strErrmsg="";
 if(strCloth.slice(0,2)!=strColor.slice(0,2)){
  linkmsg.style.visibility="visible";
  strErrmsg="カラーを選択してください";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =true;
 }else if(strCloth.slice(0,2)=="mo"&&strColor.slice(0,2)=="mo"){
  if(strCloth.slice(0,3)!=strColor.slice(0,3)){
   linkmsg.style.visibility="visible";
   strErrmsg="カラーを選択してください";
   document.getElementById("price").value=""
   document.frm_detail.checkbtn.disabled =true;
     }else{
   linkmsg.style.visibility="hidden";
   linkmsg.innerHTML="";
   document.getElementById("price").value=""
   document.frm_detail.checkbtn.disabled =false;
     }
 }else{
  linkmsg.style.visibility="hidden";
  linkmsg.innerHTML="";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =false;
 }
 if(strErrmsg!=""){
 linkmsg.innerHTML=strErrmsg;
    }
}

function checkOption(){
 document.getElementById("price").value=""
 cart_price.innerHTML =""+" 円";
 cart_haba.innerHTML="";
 cart_depth.innerHTML="";
 cart_height.innerHTML="";
 cart_cloth.innerHTML="";
 cart_color.innerHTML="";
 cart_option.innerHTML="";
 additional_fee.innerHTML="";
 linkmsg.style.visibility="hidden"; //190208追加
}


const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_top\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,haba,depth,height,price,cloth){
this.url=url;this.haba=haba;this.depth=depth;this.height=height;this.price=price;this.cloth=cloth;}
function searchURL(strHaba,strDepth,strHeight,strCloth,strOption){
var strErr;
var intDepth=document.getElementById("depth").value
var intHaba=document.getElementById("haba").value
var intHeight=document.getElementById("height").value
intDepth=parseInt(intDepth);
intHaba=parseInt(intHaba);
intHeight=parseInt(intHeight);
//幅チェック
if (intHaba < 40){
 strErr="幅40cm未満";
}else if (intHaba > 200){
  strErr="幅200cm以上";
}
//奥行チェック
if (intDepth < 40){
 strErr="奥行40cm未満";
}else if (intDepth > 150){
  strErr="奥行150cm以上"
} 
//幅と奥行きチェック
if (intHaba > 150 && intDepth > 100){
 strErr="幅151cm以上の場合、奥行101cm以上";
} 
//高さチェック
if (intHeight < 35){
 strErr="高さ35cm未満";
}else if (intHeight > 45){
 strErr="高さ45cm以上";
}
if(strErr){document.getElementById("price").value="";
return strErr+"はオーダー不可です。";}
//幅サイズ成形
switch(strHaba.length){
 case 2:
  if(strHaba.slice(0,1)=="9" && strHaba.slice(-1)!="0"){
   strHaba ="100";
  }else if(strHaba.slice(-1) !="0"){
   strHaba=parseInt(strHaba.slice(0,1))+1+"0";
  }else{
   
  }
  break;
 case 3:
  if(strHaba.slice(-1)=="0"){
   
  }else{
   if(strHaba.slice(1,2)=="9" && strHaba.slice(-1)!="0"){
    strHaba="200";
   }else{
    strHaba=strHaba.slice(0,1)+parseInt(parseInt(strHaba.slice(1,2))+1)+"0";
   }
  }
  break;
} 
//奥行サイズ成型
switch(strDepth.length){
 case 2:
  if(strDepth.slice(0,1)=="9" && strDepth.slice(-1)!="0"){
   strDepth ="100";
  }else if(strDepth.slice(-1) !="0"){
   strDepth=parseInt(strDepth.slice(0,1))+1+"0";
  }else{
   
  }
  break;
 case 3:
  if(strDepth.slice(-1)=="0"){
   
  }else{
  strDepth=strDepth.slice(0,1)+parseInt(parseInt(strDepth.slice(1,2))+1)+"0";
  }
  break;
} 
//ベース価格
var basePrice = [22000,24000,26000];
var addPriceWidth = [2000,3000,5000];
var addPriceDepth = [5000,7000];
var mulHaba;
var mulDepth;
var calMul;
var sellPrice;
var i=0;
 mulHaba=(strHaba-40)/10;
 mulDepth=(strDepth-40)/10;
 strHaba=parseInt(strHaba);
 strDepth=parseInt(strDepth);
  if(strCloth=="ns7" || strCloth=="sofia" || strCloth=="modern" || strCloth=="meisai" || strCloth=="oct" || strCloth=="flower" || strCloth=="illust" || strCloth=="pattern" || strCloth=="resort"){
   switch(true){
    case mulHaba<=8 && mulDepth<=8:
     if(strHaba > strDepth){
      sellPrice = basePrice[i]+(addPriceWidth[i]*mulHaba)+(addPriceDepth[i]*mulDepth);
     }else if(strHaba <= strDepth){
      sellPrice = basePrice[i]+(addPriceWidth[i]*mulDepth)+(addPriceDepth[i]*mulHaba);
     }
     break;
    case mulHaba<=8&&mulDepth>=9:
      calMul = mulDepth - 8;
      sellPrice = basePrice[i]+(addPriceWidth[i]*8)+(addPriceDepth[i]*mulHaba)+(addPriceWidth[i+2]*calMul);
     break;
    case mulHaba>=9&&mulDepth<=8:
      calMul = mulHaba - 8;
      sellPrice = basePrice[i]+(addPriceWidth[i]*8)+(addPriceDepth[i]*mulDepth)+(addPriceWidth[i+2]*calMul);
     break;
    case mulHaba>=9&&mulDepth>=9:
     if(strHaba > strDepth){
      calMul = mulHaba - 8;
      sellPrice = basePrice[i]+(addPriceWidth[i]*8)+(addPriceDepth[i]*mulDepth)+(addPriceWidth[i+2]*calMul);
     }else if(strHaba <= strDepth){
      calMul = mulDepth - 8;
      sellPrice = basePrice[i]+(addPriceWidth[i]*8)+(addPriceDepth[i]*mulHaba)+(addPriceWidth[i+2]*calMul);
     }
     break;
     
   }
   }else if(strCloth=="leather" || strCloth=="chappy" || strCloth=="denim" || strCloth=="damaska" || strCloth=="damaskb" || strCloth=="magic" || strCloth=="moq" || strCloth=="holiday" || strCloth=="meta"){
   switch(true){
    case mulHaba<=8 && mulDepth<=8:
     if(strHaba > strDepth){
      sellPrice = basePrice[i+1]+(addPriceWidth[i+1]*mulHaba)+(addPriceDepth[i+1]*mulDepth);
     }else if(strHaba <= strDepth){
      sellPrice = basePrice[i+1]+(addPriceWidth[i+1]*mulDepth)+(addPriceDepth[i+1]*mulHaba);
     }
     break;
    case mulHaba<=8&&mulDepth>=9:
      calMul = mulDepth - 8;
      sellPrice = basePrice[i+1]+(addPriceWidth[i+1]*8)+(addPriceDepth[i+1]*mulHaba)+(addPriceWidth[i+2]*calMul);
     break;
    case mulHaba>=9&&mulDepth<=8:
      calMul = mulHaba - 8;
      sellPrice = basePrice[i+1]+(addPriceWidth[i+1]*8)+(addPriceDepth[i+1]*mulDepth)+(addPriceWidth[i+2]*calMul);
     break;
    case mulHaba>=9&&mulDepth>=9:
     if(strHaba > strDepth){
      calMul = mulHaba - 8;
      sellPrice = basePrice[i+1]+(addPriceWidth[i+1]*8)+(addPriceDepth[i+1]*mulDepth)+(addPriceWidth[i+2]*calMul);
     }else if(strHaba <= strDepth){
      calMul = mulDepth - 8;
      sellPrice = basePrice[i+1]+(addPriceWidth[i+1]*8)+(addPriceDepth[i+1]*mulHaba)+(addPriceWidth[i+2]*calMul);
     }
     break;
     
   }
  }else if(strCloth=="michael"){
   switch(true){
    case mulHaba<=8 && mulDepth<=8:
     if(strHaba > strDepth){
      sellPrice = basePrice[i+2]+(addPriceWidth[i+1]*mulHaba)+(addPriceDepth[i+1]*mulDepth);
     }else if(strHaba <= strDepth){
      sellPrice = basePrice[i+2]+(addPriceWidth[i+1]*mulDepth)+(addPriceDepth[i+1]*mulHaba);
     }
     break;
    case mulHaba<=8&&mulDepth>=9:
      calMul = mulDepth - 8;
      sellPrice = basePrice[i+2]+(addPriceWidth[i+1]*8)+(addPriceDepth[i+1]*mulHaba)+(addPriceWidth[i+2]*calMul);
     break;
    case mulHaba>=9&&mulDepth<=8:
      calMul = mulHaba - 8;
      sellPrice = basePrice[i+2]+(addPriceWidth[i+1]*8)+(addPriceDepth[i+1]*mulDepth)+(addPriceWidth[i+2]*calMul);
     break;
    case mulHaba>=9&&mulDepth>=9:
     if(strHaba > strDepth){
      calMul = mulHaba - 8;
      sellPrice = basePrice[i+2]+(addPriceWidth[i+1]*8)+(addPriceDepth[i+1]*mulDepth)+(addPriceWidth[i+2]*calMul);
     }else if(strHaba <= strDepth){
      calMul = mulDepth - 8;
      sellPrice = basePrice[i+2]+(addPriceWidth[i+1]*8)+(addPriceDepth[i+1]*mulHaba)+(addPriceWidth[i+2]*calMul);
     }
     break;
   }
  }else{
   alert("生地を選択してください");
   return false;
  }
 var existingprice=checkPrice(strHaba,strDepth,strHeight,strCloth,strOption);
 if(!existingprice == ""){
 existingprice=parseInt(existingprice);
  if(strOption!="noleg"){
   sellPrice = existingprice+3000;
   return sellPrice;
  }else if(strOption=="noleg"){
   sellPrice = existingprice;
   return sellPrice;
  }
 }else if(existingprice == ""){
  if(strOption!="noleg"){
   sellPrice = sellPrice+3000;
   return sellPrice;
  }else if(strOption=="noleg"){
   return sellPrice;
  }
 }
}
/*リストから商品URLを取得*/
function checkURL(strHaba,strDepth,strHeight,strCloth){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].cloth==strCloth){
return goods[i].url;}}
return false;
}
/*リストから価格を取得*/
function checkPrice(strHaba,strDepth,strHeight,strCloth){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].cloth==strCloth){
return goods[i].price;}}
return false;
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
 document.getElementById("price").value =""+" 円";
 cart_price.innerHTML =""+" 円";
 cart_haba.innerHTML="";
 cart_depth.innerHTML="";
 cart_height.innerHTML="";
 cart_cloth.innerHTML="";
 cart_color.innerHTML="";
 cart_option.innerHTML=""; 
 additional_fee.innerHTML="";
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=document.getElementById("depth").value;
var strHaba=document.getElementById("haba").value;
var strHeight=document.getElementById("height").value;
var idCloth = document.getElementsByName( "cava_tab" ) ;
var idColor = document.getElementsByName( "colortype" ) ;
var idOption = document.getElementsByName( "option" ) ;
var strCloth = "";
var strColor = "";
var strOption = "";
var i=0;
var a=0;
var c=0;
for ( strCloth="", i=idCloth.length; i--; ) {
 if ( idCloth[i].checked ) {
  strCloth = idCloth[i].id.slice(4);
  var valueCloth = idCloth[i].value ;
  break ;
 }
}
for ( strColor="", a=idColor.length; a--; ) {
 if ( idColor[a].checked ) {
  strColor = idColor[a].id ;
  var valueColor = idColor[a].value ;
  break ;
 }
}
for ( strOption="", c=idOption.length; c--; ) {
 if ( idOption[c].checked ) {
  strOption = idOption[c].id ;
  var total=0;
  if( strOption!="noleg" ){total = 3000;}else{total=0;}
  var valueOption = idOption[c].value ;
  break ;
 }
}
if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (isNumber(strDepth)==false){
alert("奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (isNumber(strHeight)==false){
alert("高さは『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=strDepth+"cm"
document.getElementById("choice3").value=strHeight+"cm"
document.getElementById("choice4").value=valueCloth+"生地"
document.getElementById("choice5").value=valueColor
document.getElementById("choice6").value=valueOption
document.getElementById("choice8").value=total
//商品ページの有無チェック（別注色シルバーグレー追加）
var comcode=checkURL(strHaba,strDepth,strHeight,strCloth,strOption,strColor);
if (!comcode=="" && strColor=="moq_sgy" && strOption=="noleg"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="モケット生地シルバーグレーは別注色のため金額が異なります。";
}
else if (!comcode=="" && strOption=="noleg"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
var url=searchURL(strHaba,strDepth,strHeight,strCloth,strOption);
if(!url){
alert("幅を入力してください");
return false;
}
var intUnit
if (isNaN(url)==false){
 intUnit=parseInt(url)/1000;
 document.getElementById("price").value =parseInt(url).toLocaleString()+" 円";
 cart_price.innerHTML =parseInt(url).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_depth.innerHTML=strDepth;
 cart_height.innerHTML=strHeight;
 cart_cloth.innerHTML=valueCloth;
 cart_color.innerHTML=valueColor;
 cart_option.innerHTML=valueOption;
 additional_fee.innerHTML=total;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice7").value="見積もり金額："+url;
return false;
}
function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;
    var text = document.frm.inventory_id.value;
    var price = document.frm_detail.price.value;
    if(choice1=="" || choice2=="" || choice3=="") {
        alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
        return false;
        }           

    if(price=="") {
        alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
        return false;
        }       
     return true;
}
goods = new Object();
goods[0] =new setGoods("0000a26051","40","40","40","14000","sofia");
goods[1] =new setGoods("0000a26063","40","40","40","14000","modern");
goods[2] =new setGoods("0000a26066","40","40","40","14000","ns7");
goods[3] =new setGoods("0000a26079","40","40","40","17000","leather");
goods[4] =new setGoods("0000a26083","40","40","40","17000","moq");
goods[5] =new setGoods("0000a26095","40","40","40","14000","meisai");
goods[6] =new setGoods("0000a26098","40","40","40","17000","magic");
goods[7] =new setGoods("0000a26113","40","40","40","14000","illust");
goods[8] =new setGoods("0000a26118","40","40","40","14000","pattern");
goods[9] =new setGoods("0000a26140","50","50","40","17000","sofia");
goods[10] =new setGoods("0000a26152","50","50","40","17000","modern");
goods[11] =new setGoods("0000a26155","50","50","40","17000","ns7");
goods[12] =new setGoods("0000a26168","50","50","40","26000","leather");
goods[13] =new setGoods("0000a26172","50","50","40","26000","moq");
goods[14] =new setGoods("0000a26184","50","50","40","17000","meisai");
goods[15] =new setGoods("0000a26187","50","50","40","26000","magic");
goods[16] =new setGoods("0000a26202","50","50","40","18000","illust");
goods[17] =new setGoods("0000a26207","50","50","40","18000","pattern");
goods[18] =new setGoods("0000a26229","60","60","40","20000","sofia");
goods[19] =new setGoods("0000a26241","60","60","40","20000","modern");
goods[20] =new setGoods("0000a26244","60","60","40","20000","ns7");
goods[21] =new setGoods("0000a26257","60","60","40","31000","leather");
goods[22] =new setGoods("0000a26261","60","60","40","31000","moq");
goods[23] =new setGoods("0000a26273","60","60","40","20000","meisai");
goods[24] =new setGoods("0000a26276","60","60","40","31000","magic");
goods[25] =new setGoods("0000a26291","60","60","40","23000","illust");
goods[26] =new setGoods("0000a26296","60","60","40","23000","pattern");
goods[27] =new setGoods("0000a26318","70","70","40","24000","sofia");
goods[28] =new setGoods("0000a26330","70","70","40","24000","modern");
goods[29] =new setGoods("0000a26333","70","70","40","24000","ns7");
goods[30] =new setGoods("0000a26346","70","70","40","35000","leather");
goods[31] =new setGoods("0000a26350","70","70","40","35000","moq");
goods[32] =new setGoods("0000a26362","70","70","40","24000","meisai");
goods[33] =new setGoods("0000a26365","70","70","40","35000","magic");
goods[34] =new setGoods("0000a26380","70","70","40","26000","illust");
goods[35] =new setGoods("0000a26385","70","70","40","26000","pattern");
goods[36] =new setGoods("0000a26407","80","80","40","28000","sofia");
goods[37] =new setGoods("0000a26419","80","80","40","28000","modern");
goods[38] =new setGoods("0000a26422","80","80","40","28000","ns7");
goods[39] =new setGoods("0000a26435","80","80","40","43000","leather");
goods[40] =new setGoods("0000a26439","80","80","40","43000","moq");
goods[41] =new setGoods("0000a26451","80","80","40","28000","meisai");
goods[42] =new setGoods("0000a26454","80","80","40","43000","magic");
goods[43] =new setGoods("0000a26469","80","80","40","30000","illust");
goods[44] =new setGoods("0000a26474","80","80","40","30000","pattern");
goods[45] =new setGoods("0000a26496","90","90","40","33000","sofia");
goods[46] =new setGoods("0000a26508","90","90","40","33000","modern");
goods[47] =new setGoods("0000a26511","90","90","40","33000","ns7");
goods[48] =new setGoods("0000a26524","90","90","40","49000","leather");
goods[49] =new setGoods("0000a26528","90","90","40","49000","moq");
goods[50] =new setGoods("0000a26540","90","90","40","33000","meisai");
goods[51] =new setGoods("0000a26543","90","90","40","49000","magic");
goods[52] =new setGoods("0000a26558","90","90","40","35000","illust");
goods[53] =new setGoods("0000a26563","90","90","40","35000","pattern");
goods[54] =new setGoods("0000a28443","120","120","40","55000","sofia");
goods[55] =new setGoods("0000a28455","150","150","40","72000","sofia");
goods[56] =new setGoods("0000a28467","120","48","40","28000","sofia");
goods[57] =new setGoods("0000a28479","144","48","40","34000","sofia");
goods[58] =new setGoods("0000a28491","168","48","40","40000","sofia");
goods[59] =new setGoods("0000a28503","192","48","40","51000","sofia");
goods[60] =new setGoods("0000a28515","120","72","40","40000","sofia");
goods[61] =new setGoods("0000a28527","144","72","40","46000","sofia");
goods[62] =new setGoods("0000a28539","168","72","40","51000","sofia");
goods[63] =new setGoods("0000a28551","192","72","40","69000","sofia");
goods[64] =new setGoods("0000a32210","120","120","40","55000","ns7");
goods[65] =new setGoods("0000a32216","120","120","40","55000","modern");
goods[66] =new setGoods("0000a32223","120","120","40","71000","moq");
goods[67] =new setGoods("0000a32233","120","120","40","71000","leather");
goods[68] =new setGoods("0000a32261","120","120","40","55000","meisai");
goods[69] =new setGoods("0000a32269","120","120","40","71000","magic");
goods[70] =new setGoods("0000a32276","120","120","40","55000","illust");
goods[71] =new setGoods("0000a32281","120","120","40","55000","pattern");
goods[72] =new setGoods("0000a32287","150","150","40","72000","ns7");
goods[73] =new setGoods("0000a32293","150","150","40","72000","modern");
goods[74] =new setGoods("0000a32300","150","150","40","92000","moq");
goods[75] =new setGoods("0000a32310","150","150","40","92000","leather");
goods[76] =new setGoods("0000a32338","150","150","40","72000","meisai");
goods[77] =new setGoods("0000a32346","150","150","40","92000","magic");
goods[78] =new setGoods("0000a32353","150","150","40","72000","illust");
goods[79] =new setGoods("0000a32358","150","150","40","72000","pattern");
goods[80] =new setGoods("0000a36716","40","40","40","18000","michael");
goods[81] =new setGoods("0000a36726","50","50","40","26000","michael");
goods[82] =new setGoods("0000a36736","60","60","40","33000","michael");
goods[83] =new setGoods("0000a36746","70","70","40","36000","michael");
goods[84] =new setGoods("0000a36756","80","80","40","43000","michael");
goods[85] =new setGoods("0000a36766","90","90","40","50000","michael");
goods[86] =new setGoods("0000a36776","120","120","40","72000","michael");
goods[87] =new setGoods("0000a36786","150","150","40","94000","michael");
goods[88] =new setGoods("0000a36856","120","48","40","28000","ns7");
goods[89] =new setGoods("0000a36862","120","48","40","28000","modern");
goods[90] =new setGoods("0000a36869","120","48","40","38000","moq");
goods[91] =new setGoods("0000a36879","120","48","40","38000","leather");
goods[92] =new setGoods("0000a36907","120","48","40","28000","meisai");
goods[93] =new setGoods("0000a36915","120","48","40","38000","magic");
goods[94] =new setGoods("0000a36922","120","48","40","28000","illust");
goods[95] =new setGoods("0000a36927","120","48","40","28000","pattern");
goods[96] =new setGoods("0000a36933","144","48","40","34000","ns7");
goods[97] =new setGoods("0000a36939","144","48","40","34000","modern");
goods[98] =new setGoods("0000a36946","144","48","40","43000","moq");
goods[99] =new setGoods("0000a36956","144","48","40","43000","leather");
goods[100] =new setGoods("0000a36984","144","48","40","34000","meisai");
goods[101] =new setGoods("0000a36992","144","48","40","43000","magic");
goods[102] =new setGoods("0000a36999","144","48","40","34000","illust");
goods[103] =new setGoods("0000a37004","144","48","40","34000","pattern");
goods[104] =new setGoods("0000a37010","168","48","40","40000","ns7");
goods[105] =new setGoods("0000a37016","168","48","40","40000","modern");
goods[106] =new setGoods("0000a37023","168","48","40","48000","moq");
goods[107] =new setGoods("0000a37033","168","48","40","48000","leather");
goods[108] =new setGoods("0000a37061","168","48","40","40000","meisai");
goods[109] =new setGoods("0000a37069","168","48","40","48000","magic");
goods[110] =new setGoods("0000a37076","168","48","40","40000","illust");
goods[111] =new setGoods("0000a37081","168","48","40","40000","pattern");
goods[112] =new setGoods("0000a37087","192","48","40","51000","ns7");
goods[113] =new setGoods("0000a37093","192","48","40","51000","modern");
goods[114] =new setGoods("0000a37100","192","48","40","61000","moq");
goods[115] =new setGoods("0000a37110","192","48","40","61000","leather");
goods[116] =new setGoods("0000a37138","192","48","40","51000","meisai");
goods[117] =new setGoods("0000a37146","192","48","40","61000","magic");
goods[118] =new setGoods("0000a37153","192","48","40","51000","illust");
goods[119] =new setGoods("0000a37158","192","48","40","51000","pattern");
goods[120] =new setGoods("0000a37164","120","72","40","40000","ns7");
goods[121] =new setGoods("0000a37170","120","72","40","40000","modern");
goods[122] =new setGoods("0000a37177","120","72","40","51000","moq");
goods[123] =new setGoods("0000a37187","120","72","40","51000","leather");
goods[124] =new setGoods("0000a37215","120","72","40","40000","meisai");
goods[125] =new setGoods("0000a37223","120","72","40","51000","magic");
goods[126] =new setGoods("0000a37230","120","72","40","40000","illust");
goods[127] =new setGoods("0000a37235","120","72","40","40000","pattern");
goods[128] =new setGoods("0000a37241","144","72","40","46000","ns7");
goods[129] =new setGoods("0000a37247","144","72","40","46000","modern");
goods[130] =new setGoods("0000a37254","144","72","40","58000","moq");
goods[131] =new setGoods("0000a37264","144","72","40","58000","leather");
goods[132] =new setGoods("0000a37292","144","72","40","46000","meisai");
goods[133] =new setGoods("0000a37300","144","72","40","58000","magic");
goods[134] =new setGoods("0000a37307","144","72","40","46000","illust");
goods[135] =new setGoods("0000a37312","144","72","40","46000","pattern");
goods[136] =new setGoods("0000a37318","168","72","40","51000","ns7");
goods[137] =new setGoods("0000a37324","168","72","40","51000","modern");
goods[138] =new setGoods("0000a37331","168","72","40","66000","moq");
goods[139] =new setGoods("0000a37341","168","72","40","66000","leather");
goods[140] =new setGoods("0000a37369","168","72","40","51000","meisai");
goods[141] =new setGoods("0000a37377","168","72","40","66000","magic");
goods[142] =new setGoods("0000a37384","168","72","40","51000","illust");
goods[143] =new setGoods("0000a37389","168","72","40","51000","pattern");
goods[144] =new setGoods("0000a37395","192","72","40","69000","ns7");
goods[145] =new setGoods("0000a37401","192","72","40","69000","modern");
goods[146] =new setGoods("0000a37408","192","72","40","85000","moq");
goods[147] =new setGoods("0000a37418","192","72","40","85000","leather");
goods[148] =new setGoods("0000a37446","192","72","40","69000","meisai");
goods[149] =new setGoods("0000a37454","192","72","40","85000","magic");
goods[150] =new setGoods("0000a37461","192","72","40","69000","illust");
goods[151] =new setGoods("0000a37466","192","72","40","69000","pattern");
goods[152] =new setGoods("0000a38307","120","48","40","40000","michael");
goods[153] =new setGoods("0000a38317","144","48","40","44000","michael");
goods[154] =new setGoods("0000a38327","168","48","40","50000","michael");
goods[155] =new setGoods("0000a38337","192","48","40","63000","michael");
goods[156] =new setGoods("0000a38347","120","72","40","54000","michael");
goods[157] =new setGoods("0000a38357","144","72","40","61000","michael");
goods[158] =new setGoods("0000a38367","168","72","40","69000","michael");
goods[159] =new setGoods("0000a38377","192","72","40","87000","michael");
goods[160] =new setGoods("0000a41590","40","40","40","17000","denim");
goods[161] =new setGoods("0000a41595","50","50","40","26000","denim");
goods[162] =new setGoods("0000a41600","60","60","40","31000","denim");
goods[163] =new setGoods("0000a41605","70","70","40","35000","denim");
goods[164] =new setGoods("0000a41610","80","80","40","43000","denim");
goods[165] =new setGoods("0000a41615","90","90","40","49000","denim");
goods[166] =new setGoods("0000a41620","120","120","40","71000","denim");
goods[167] =new setGoods("0000a41625","150","150","40","92000","denim");
goods[168] =new setGoods("0000a41630","120","48","40","38000","denim");
goods[169] =new setGoods("0000a41635","144","48","40","43000","denim");
goods[170] =new setGoods("0000a41640","168","48","40","48000","denim");
goods[171] =new setGoods("0000a41645","192","48","40","61000","denim");
goods[172] =new setGoods("0000a41650","120","72","40","51000","denim");
goods[173] =new setGoods("0000a41655","144","72","40","58000","denim");
goods[174] =new setGoods("0000a41660","168","72","40","66000","denim");
goods[175] =new setGoods("0000a41665","192","72","40","85000","denim");
goods[176] =new setGoods("0000ae017935","40","40","40","15000","resort");
goods[177] =new setGoods("0000ae017940","40","40","40","17000","holiday");
goods[178] =new setGoods("0000ae017945","40","40","40","17000","meta");
goods[179] =new setGoods("0000ae017953","50","50","40","20000","resort");
goods[180] =new setGoods("0000ae017958","50","50","40","26000","holiday");
goods[181] =new setGoods("0000ae017963","50","50","40","26000","meta");
goods[182] =new setGoods("0000ae017971","60","60","40","24000","resort");
goods[183] =new setGoods("0000ae017976","60","60","40","31000","holiday");
goods[184] =new setGoods("0000ae017981","60","60","40","31000","meta");
goods[185] =new setGoods("0000ae017989","70","70","40","30000","resort");
goods[186] =new setGoods("0000ae017994","70","70","40","35000","holiday");
goods[187] =new setGoods("0000ae017999","70","70","40","35000","meta");
goods[188] =new setGoods("0000ae018007","80","80","40","36000","resort");
goods[189] =new setGoods("0000ae018012","80","80","40","43000","holiday");
goods[190] =new setGoods("0000ae018017","80","80","40","43000","meta");
goods[191] =new setGoods("0000ae018025","90","90","40","40000","resort");
goods[192] =new setGoods("0000ae018030","90","90","40","49000","holiday");
goods[193] =new setGoods("0000ae018035","90","90","40","49000","meta");
goods[194] =new setGoods("0000ae018043","120","120","40","62000","resort");
goods[195] =new setGoods("0000ae018048","120","120","40","71000","holiday");
goods[196] =new setGoods("0000ae018053","120","120","40","71000","meta");
goods[197] =new setGoods("0000ae018061","150","150","40","82000","resort");
goods[198] =new setGoods("0000ae018066","150","150","40","92000","holiday");
goods[199] =new setGoods("0000ae018071","150","150","40","92000","meta");
goods[200] =new setGoods("0000ae018079","120","48","40","32000","resort");
goods[201] =new setGoods("0000ae018084","120","48","40","38000","holiday");
goods[202] =new setGoods("0000ae018089","120","48","40","38000","meta");
goods[203] =new setGoods("0000ae018097","144","48","40","38000","resort");
goods[204] =new setGoods("0000ae018102","144","48","40","43000","holiday");
goods[205] =new setGoods("0000ae018107","144","48","40","43000","meta");
goods[206] =new setGoods("0000ae018115","168","48","40","43000","resort");
goods[207] =new setGoods("0000ae018120","168","48","40","48000","holiday");
goods[208] =new setGoods("0000ae018125","168","48","40","48000","meta");
goods[209] =new setGoods("0000ae018133","192","48","40","59000","resort");
goods[210] =new setGoods("0000ae018138","192","48","40","61000","holiday");
goods[211] =new setGoods("0000ae018143","192","48","40","61000","meta");
goods[212] =new setGoods("0000ae018151","120","72","40","44000","resort");
goods[213] =new setGoods("0000ae018156","120","72","40","51000","holiday");
goods[214] =new setGoods("0000ae018161","120","72","40","51000","meta");
goods[215] =new setGoods("0000ae018169","144","72","40","52000","resort");
goods[216] =new setGoods("0000ae018174","144","72","40","58000","holiday");
goods[217] =new setGoods("0000ae018179","144","72","40","58000","meta");
goods[218] =new setGoods("0000ae018187","168","72","40","59000","resort");
goods[219] =new setGoods("0000ae018192","168","72","40","66000","holiday");
goods[220] =new setGoods("0000ae018197","168","72","40","66000","meta");
goods[221] =new setGoods("0000ae018205","192","72","40","76000","resort");
goods[222] =new setGoods("0000ae018210","192","72","40","85000","holiday");
goods[223] =new setGoods("0000ae018215","192","72","40","85000","meta");
